/*
 *in this module there are all the functions that handle the psa staff buttons in the popup
 */

/**
 * import modules
 */

import psalayers from '../psastaff/psalayers'

/**
 * initialize the dummy parameter to update the layer
 * has to be global has we call those functions each time we create a popup
 * doing so we reset all the time the var if it's inside
 */

let iDelRef = 0

/**
 * delete the suspension
 */

function psaDeleteItem (overlay) {
  $('.psadelbtn').on('click', () => {
    /**
     * get the id of the .psadelbtn button and split it by __
     * from that get and save the:
     *  - suspid
     *  - tstamp
     */

    const temp = $('.psadelbtn').attr('id').split('_')
    const suspid = temp[0]
    const tstamp = temp[1]

    /**
     * display the confirmation modal
     * populate the psadeleteorder with suspid
     */

    $('#delconf').modal('show')
    $('.psadeleteorder').html(suspid)

    /**
     * okCancel click handler
     */

    $('.okCancel').on('click', function () {
      /**
       * hide the confirmation modal
       */

      $('#delconf').modal('hide')

      let theData = '{"suspid": "' + suspid + '"}'

      /**
       * send an ajax reuqest
       */
      $('.loading').show()
      $.ajax({
       url: '/traffweb/psa-delete',
       type:"POST",
       data: {
         jdata: theData
       },
       beforeSend: function beforeSend(xhr) {
         xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
       }
      })
        .done(() => {
          /**
           * parse the result if is the dev server with webpack
           */
          iDelRef += 1
          psalayers.updateLayerParams($('#featclick').val(), iDelRef)
  
        }) // end done
        .fail(function (jqxhr, textStatus, error) {
          const err = `${textStatus}, ${error}`
          alert(`THEURLS Request Failed: ${err}`)
        })
        .always(() => {
          /**
           * hide the loading bar
           */

          $('.loading').hide()
        })
      /**
       * reset psadeleteorder
       * hide the popup and the mobile popup
       */

      $('.psadeleteorder').html('')
      overlay.setPosition(undefined)
      $('#mobpopup').modal('hide')
    })

    /**
     * deleteCancel click handler
     */

    $('.deleteCancel').on('click', function () {
      /**
       * hide the confirmation modal
       * reset psadeleteorder
       */

      $('#delconf').modal('hide')
      $('.psadeleteorder').html('')
    })

    /**
     * end function psaDeleteItem(thelink) {
     * end $('.edit-action').on('click', () => {
     */
  })
}

/**
 * EXPORT
 */

export default {
  psaDeleteItem
}
